export function findTransactionsByCategory(expenseTransactions, incomeTransactions, categoryId) {
    const expense = expenseTransactions
        .filter((item) => item.categoryId === categoryId)
        .sort((a, b) => {
            return a.amount - b.amount;
        });

    const income = incomeTransactions
        .filter((item) => item.categoryId === categoryId)
        .sort((a, b) => {
            return a.amount - b.amount;
        });

    const result = [...expense, ...income].sort((a, b) => {
        return a.amount - b.amount;
    });
    return result;
}
